
import React from "react";
import { useTheme, Theme } from "@/hooks/use-theme";
import { Label } from "@/components/ui/label";
import { ThemePreview } from "./theme/ThemePreview";
import { Loader2 } from "lucide-react";

export const StylesTab = () => {
  const { theme, setTheme, isLoading } = useTheme();

  const handleThemeChange = (newTheme: Theme) => {
    console.log("User selected theme:", newTheme);
    setTheme(newTheme);
  };

  const themes: { id: Theme; name: string }[] = [
    { id: "light", name: "Claro" },
    { id: "dark", name: "Oscuro" },
    { id: "system", name: "Sistema" },
    { id: "ocean", name: "Océano" },
    { id: "sunset", name: "Atardecer" },
    { id: "forest", name: "Bosque" }
  ];

  if (isLoading) {
    return (
      <div className="space-y-6 styles-section">
        <div className="space-y-3">
          <Label className="text-lg font-semibold">Tema de la aplicación</Label>
          <p className="text-sm text-muted-foreground">
            Cargando configuración de tema...
          </p>
          <div className="flex items-center justify-center py-8">
            <Loader2 className="h-6 w-6 animate-spin" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6 styles-section">
      <div className="space-y-3">
        <Label className="text-lg font-semibold">Tema de la aplicación</Label>
        <p className="text-sm text-muted-foreground">
          Personaliza la apariencia de Clubbers según tus preferencias
        </p>
        
        <div className="grid grid-cols-3 gap-4 pt-2">
          {themes.map((item) => (
            <ThemePreview
              key={item.id}
              theme={item.id}
              currentTheme={theme}
              onClick={handleThemeChange}
              name={item.name}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
